<template>
  <h4
    class="everything"
  >
    <b-form-select
      v-model="month"
      class="mr-1 monthSelect"
      :options="months"
    />
    <b-form-input
      v-model="year"
      class="yearInput"
      type="number"
    />
  </h4>
</template>

<script>

import { BFormInput, BFormSelect } from 'bootstrap-vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CalendarNavigationInputs',
  components: {
    BFormSelect,
    BFormInput
  },
  data () {
    return {
      months: [
        {
          text: 'Januar',
          value: 1
        },
        {
          text: 'Februar',
          value: 2
        },
        {
          text: 'März',
          value: 3
        },
        {
          text: 'April',
          value: 4
        },
        {
          text: 'Mai',
          value: 5
        },
        {
          text: 'Juni',
          value: 6
        },
        {
          text: 'Juli',
          value: 7
        },
        {
          text: 'August',
          value: 8
        },
        {
          text: 'September',
          value: 9
        },
        {
          text: 'Oktober',
          value: 10
        },
        {
          text: 'November',
          value: 11
        },
        {
          text: 'Dezember',
          value: 12
        }
      ]
    }
  },
  computed: {
    ...mapGetters('calendar', [
      'getYear',
      'getMonth'
    ]),
    year: {
      get () {
        return this.getYear
      },
      set (value) {
        this.SET_YEAR(value)
      }
    },
    month: {
      get () {
        return this.getMonth
      },
      set (value) {
        this.SET_MONTH(value)
      }
    }
  },
  methods: {
    ...mapMutations('calendar', [
      'SET_YEAR',
      'SET_MONTH'
    ])
  }
}
</script>

<style scoped>

.everything {
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 0
}

.monthSelect {
  width: auto;
  border: none;
  box-shadow: none;
  font-size: inherit;
  font-weight: inherit;
  background: none;
  padding: 0 0 0 8px;
  text-align: center;
  text-align-all: center;
  text-align-last: center
}

.yearInput {
  width: 8ch;
  border: none;
  box-shadow: none;
  font-size: inherit;
  font-weight: inherit;
}
</style>
